import { render, staticRenderFns } from "./inner-page.vue?vue&type=template&id=92144a60&scoped=true&lang=pug"
import script from "./inner-page.vue?vue&type=script&lang=ts"
export * from "./inner-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92144a60",
  null
  
)

export default component.exports